<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="日期">
                    <el-date-picker v-model="dateTimer" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="关键词">
                    <el-input v-model="params.keyword" placeholder="ERP编码、员工编号、用户名、所属办事处、姓名、手机、Email" clearable style="width: 420px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCreditAgentScores(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                评分列表
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="getCreditAgentScoresExport()">导出查询信息</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-table :data="tabledata" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="OwnerName" label="业务员名称" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_AgentScore_UserCode" label="业务员编号" align="center" width="120"></el-table-column>
                <el-table-column prop="OfficeName" label="所属办事处" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_AgentScore_InitialAmount" label="基本合作规模" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_AgentScore_LawyerLetterAmount" label="律师函调整金额" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_AgentScore_ReminderLetterAmount" label="催款函调整金额" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_AgentScore_RepaymentPlanAmount" label="还款计划调整额" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_AgentScore_InitialScore" label="基本评分" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_AgentScore_OverdueReturnScore" label="客户逾期欠款调整分" align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_AgentScore_OnTimeRateScore" label="书面计划完成调整分" align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_AgentScore_WrittenScore" label="书面确认调整分" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_AgentScore_CommercialBillScore" label="商业承兑汇票调整分" align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_AgentScore_TotalScore" label="最终评分" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_AgentScore_Addtime" label="评分日期" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_AgentScore_Evaluation" label="评分评价" align="center" width="120"></el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { toLowerCaseKeys, downloadFile } from '@/utils/utils.js';
const today = new Date().toISOString().slice(0, 10); // 格式化为 'YYYY-MM-DD'
export default {
    name: 'salesmanDailyrating',
    mixins: [myMixin],
    components: {
        Pagination
    },
    data() {
        return {
            loadingBtn: false,
            params: {
                date_start: '',
                date_end: '',
                keyword: ''
            },
            tabledata: [],
            dateTimer: [today, today]
        };
    },
    mounted() {
        this.getCreditAgentScores();
    },
    methods: {
        /*
     重置
   */
        onRefresh() {
            this.dateTimer = [today, today];
            this.params = {
                date_start: '',
                date_end: '',
                keyword: ''
            };
            this.getCreditAgentScores(true);
        },
        /*
     查询列表
   */
        getCreditAgentScores(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getCreditAgentScores(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tabledata = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*
     查询报价单列表
   */
        filteropt() {
            let params = { ...this.params };
            if (this.dateTimer && this.dateTimer.length > 0) {
                params.date_start = this.dateTimer[0];
                params.date_end = this.dateTimer[1];
            }
            console.log(params, 'params');
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        /*
    导出查询列表结果
  */
        getCreditAgentScoresExport() {
            this.$newsApi
                .getCreditAgentScoresExport(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        downloadFile(res.data.data, res.data.Resultinfo);
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getCreditAgentScores();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getCreditAgentScores();
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__label {
    font-weight: 500 !important;
}
.content {
    // padding: 10px 10px;
    height: calc(100vh - 104px);
    overflow: auto;
}
.content-head {
    background: #fff;
    padding: 0px 20px 20px 20px;
    border-radius: 2px;
}
.content-head-title {
    line-height: 50px;
}
.content-table-title {
    display: flex;
    justify-content: space-between;
    line-height: 50px;
}
.content-table {
    border-radius: 2px;
    background: #fff;
    padding: 0px 20px 20px 20px;
    cursor: pointer;
    margin-top: 10px;
}
.description-view {
    padding: 0px 20px;
}
</style>
